import { render, staticRenderFns } from "./tblock.vue?vue&type=template&id=3b0e2e5c"
import script from "./tblock.vue?vue&type=script&lang=js"
export * from "./tblock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports